<div>
  <div class="geometry-type-toggle">
    <mat-button-toggle-group
      (change)="onGeometryTypeChange($event.value)"
      [value]="geometryType.Point"
    >
      <mat-button-toggle [value]="geometryType.Point">
        {{ 'igo.geo.draw.' + geometryType.Point | translate }}
      </mat-button-toggle>

      <mat-button-toggle [value]="geometryType.LineString">
        {{ 'igo.geo.draw.' + geometryType.LineString | translate }}
      </mat-button-toggle>

      <mat-button-toggle [value]="geometryType.Polygon">
        {{ 'igo.geo.draw.' + geometryType.Polygon | translate }}
      </mat-button-toggle>

      <mat-button-toggle [value]="geometryType.Circle">
        {{ 'igo.geo.draw.' + geometryType.Circle | translate }}
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <div class="draw-options">
    <mat-slide-toggle
      [disabled]="drawControlIsDisabled"
      [checked]="drawControlIsActive"
      [labelPosition]="'before'"
      (change)="onToggleDrawControl($event.checked)"
    >
      {{ 'igo.geo.draw.drawControl' | translate }}
    </mat-slide-toggle>

    <mat-slide-toggle
      [checked]="labelsAreShown"
      [labelPosition]="'before'"
      (change)="onToggleLabels()"
    >
      {{ 'igo.geo.draw.toggleMapTooltips' | translate }}
    </mat-slide-toggle>

    @if (!isPoint()) {
      <mat-slide-toggle
        [checked]="freehandMode"
        [labelPosition]="'before'"
        (change)="onToggleFreehandMode($event)"
      >
        {{ 'igo.geo.draw.freehandMode' | translate }}
      </mat-slide-toggle>
    }

    @if (isCircle()) {
      <div class="radius-unit">
        <mat-form-field class="radius">
          <input
            matInput
            type="number"
            min="0"
            placeholder="{{ 'igo.geo.spatialFilter.radius' | translate }}"
            [formControl]="radiusFormControl"
            [readonly]="this.freehandMode"
          />
        </mat-form-field>
        <mat-form-field class="unit-field">
          <mat-select
            [value]="measureUnit"
            (selectionChange)="onMeasureUnitChange($event.value)"
          >
            @for (measureUnit of measureUnits; track measureUnit) {
              <mat-option [value]="measureUnit">
                {{ 'igo.geo.measure.' + measureUnit | translate }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
  </div>

  <mat-divider />

  <div class="layer-select-container">
    <mat-form-field class="layer-select" subscriptSizing="dynamic">
      <mat-label>{{ 'igo.geo.draw.layer.title' | translate }}</mat-label>
      <mat-select
        #selectedLayer
        (selectionChange)="onLayerChange(selectedLayer.value)"
        [value]="updateActiveLayer()"
      >
        @for (layer of allLayers; track layer) {
          <mat-option [value]="layer">
            {{ layer.title }}
          </mat-option>
        }
        <mat-option id="createNewLayer">
          {{ 'igo.geo.draw.layer.createNewLayer' | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    @let drawingLayer = activeDrawingLayer();
    @if (drawingLayer) {
      <button
        mat-icon-button
        [color]="drawingLayer.visible ? 'primary' : 'accent'"
        collapsibleButton
        tooltip-position="below"
        matTooltipShowDelay="500"
        [matTooltip]="
          drawingLayer.visible
            ? ('igo.geo.layer.hideLayer' | translate)
            : ('igo.geo.layer.showLayer' | translate)
        "
        (click)="drawingLayer.visible = !drawingLayer.visible"
      >
        <mat-icon>
          {{ drawingLayer.visible ? 'visibility' : 'visibility_off' }}
        </mat-icon>
      </button>
    }
  </div>
  <mat-divider />
  <div>
    @if (activeStore.count$.getValue() > 0) {
      <button
        class="deleteBtn"
        mat-icon-button
        color="warn"
        tooltip-position="below"
        matTooltipShowDelay="500"
        [matTooltip]="'igo.geo.draw.delete' | translate"
        [disabled]="(selectedFeatures$ | async).length === 0"
        (click)="deleteDrawings()"
      >
        <mat-icon>delete</mat-icon>
      </button>
    }

    <div>
      <igo-entity-table
        #table
        class="table-compact"
        [store]="activeStore"
        [template]="tableTemplate"
      />
    </div>
  </div>

  <div class="icon-options">
    @if (icons.length >= 1) {
      <mat-form-field>
        <mat-label>{{ 'igo.geo.draw.icon' | translate }}</mat-label>
        <mat-select>
          <mat-select-trigger>
            @if (icon) {
              <div class="box">
                <img src="{{ icon }}" />
              </div>
            }
          </mat-select-trigger>
          <mat-option value="" (click)="onIconChange()">{{
            'igo.geo.draw.noIcon' | translate
          }}</mat-option>
          @for (icon_html of icons; track icon_html) {
            <mat-option [value]="icon_html" (click)="onIconChange(icon_html)">
              <div class="box">
                <img src="{{ icon_html }}" />
              </div>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  </div>

  <div class="actions-container">
    <button
      mat-icon-button
      color="accent"
      disableRipple="true"
      (click)="openShorcutsDialog()"
    >
      <mat-icon
        class="shortcuts-icon"
        tooltip-position="below"
        matTooltipShowDelay="500"
        [matTooltip]="'igo.geo.draw.shortcuts' | translate"
        >keyboard
      </mat-icon>
    </button>

    @if (selectedFeatures$.value.length) {
      <button
        matButton="elevated"
        color="primary"
        (click)="openStyleModalDialog()"
        [matTooltip]="'igo.geo.style.styleModalTooltipSelected' | translate"
      >
        {{ 'igo.geo.style.styleModal' | translate }}
        <mat-icon
          aria-hidden="false"
          iconPositionEnd
          class="style-icon"
          [matBadge]="selectedFeatures$.value.length"
          matBadgeColor="warn"
          matBadgeSize="medium"
          >palette
        </mat-icon>
      </button>
    }
  </div>
</div>
